import { Box, Flex, Text } from "@chakra-ui/react";
import { ReactNode } from "react";

export function ProgressBar({
  value = 0,
  label,
  description,
  variant = "active"
}: {
  value?: number;
  label?: ReactNode;
  description?: string;
  variant?: "active" | "paused" | "complete" | "error" | "waiting";
}) {
  const styles = {
    active: { color: "#5D5FEF", bg: "#E2E8F0" },
    paused: { color: "#A0AEC0", bg: "#EDF2F7" },
    complete: { color: "#00C04D", bg: "#E2E8F0" },
    error: { color: "#E53E3E", bg: "#FED7D7" },
    waiting: { color: "#D69E2E", bg: "#FFFAF0" }
  };

  const currentStyle = styles[variant] || styles.active;

  return (
    <Box w="100%">
      <Flex justifyContent="space-between" mb="2px" alignItems="center">
        {label && (
          <Box fontSize="14px" fontWeight="500" color="#000">
            {label}
          </Box>
        )}
        <Text fontSize="14px" fontWeight="500" ml="10px" color="#000">
          {Math.round(value)}%
        </Text>
      </Flex>
      <Box w="100%" h="6px" borderRadius="10px" bg={currentStyle.bg}>
        <Box
          w={`${value}%`}
          h="100%"
          borderRadius="10px"
          bg={currentStyle.color}
          transition="width 0.3s ease"
        />
      </Box>
      {description && (
        <Text fontSize="12px" color="#718096" mt="2px">
          {description}
        </Text>
      )}
    </Box>
  );
}
